<template>
  <div class="bar-chart">
    <div class="bar-chart__chart mb-16">
      <canvas
        class="bar-chart__canvas"
        ref="chart" />
    </div>

    <div class="bar-chart__actions">
      <a
        href="#"
        ref="downloadImageLink"
        class="btn btn--secondary btn--xs"
        @click.prevent="downloadImage">Download image</a>
    </div>
  </div>
</template>

<script>
import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle
} from 'chart.js';
import "chartjs-adapter-date-fns";

Chart.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle
);

Chart.defaults.font.size = 14;
Chart.defaults.font.family = "Muli";

import { mapGetters } from "vuex";
import downloadChartImage from "./download-image";

export default {
  data() {
    return {
      chart: null
    }
  },
  computed: {
    ...mapGetters("chart", ["title", "xAxisTitle", "yAxisTitle", "type", "stacked", "seriesColumns", "series", "fields", "result", "labels", "datasets", "datasetUpdatedAt", "xAxis", "xAxisType", "fieldTypes", "legendPosition", "showAllXAxisLabels", "optionsPlugins", "optionsXAxis", "optionsYAxis"]),
    data() {
      return {
        labels: this.labels,
        datasets: this.datasets
      }
    },
    chartOptions() {
      return {
        responsive: true,
        plugins: this.optionsPlugins,
        elements: {
          point: {
            radius: 0
          }
        },
        scales: {
          x: this.optionsXAxis,
          y: this.optionsYAxis
        }
      }
    },
    chartConfig() {
      return {
        type: "bar",
        data: this.data,
        options: this.chartOptions
      };
    }
  },
  watch: {
    result() {
      this.$nextTick(() => {
        this.updateChart();
      });
    },
    datasetUpdatedAt() {
      this.$nextTick(() => {
        this.updateChart();
      });
    }
  },
  methods: {
    updateChart() {
      if(this.chart) {
        this.chart.data = this.data;
        this.chart.options = this.chartOptions;

        this.chart.update();
      } else {
        const context = this.$refs.chart.getContext("2d");

        this.chart = new Chart(context, this.chartConfig);
      }
    },
    downloadImage() {
      downloadChartImage(this.chart);
    }
  },
  mounted() {
    this.updateChart();
  }
};
</script>

<style lang="scss">
.bar-chart {
  &__chart {
    width: 100%;
    position: relative;
  }

  &__canvas {
    width: 100%;
    height: 600px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
